import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faIndustryWindows } from '@fortawesome/pro-light-svg-icons';

export type ProLightIndustryWindowsProps = IconComponentProps;

export const ProLightIndustryWindows = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightIndustryWindowsProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faIndustryWindows}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faIndustryWindows}
    />
  );
};

ProLightIndustryWindows.displayName = 'ProLightIndustryWindows';
